











import { Component, Mixins } from 'vue-property-decorator';
import TextField from '@/components/TextField.vue';
import TextFieldsWrapper from '@/components/TextFieldsWrapper.vue';
import TextFieldElementMixin from '@/mixins/textFieldElementMixin';
import { EventBus } from '@/event-bus';
import { WIDGET_EVENTS } from '@/const/widget-events';

@Component({
  components: {
    TextField,
    TextFieldsWrapper,
  },
})
export default class TextFieldElementWidget extends Mixins(
  TextFieldElementMixin
) {
  private changeHandler(value: string) {
    EventBus.$emit(WIDGET_EVENTS.CHANGE, {
      field: this.field,
      value: value ? value : null,
    });
  }
}
